// src/store/thunks/sixDetail/deleteFileThunk.ts
import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";
import { withErrorHandling, withLoader } from "@/store/thunks/thunkWrappers";
import type { DeleteFilePayload, DeleteFileResponse } from "@/types/six/SixDTOs";

export const deleteFileThunk = createAppAsyncThunk<
  DeleteFileResponse & { fileId: string },
  DeleteFilePayload,
  { rejectValue: { message: string } }
>(
  "sixDetail/deleteFile",
  withLoader(
    withErrorHandling(async(payload, thunkAPI) => {
      const { extra } = thunkAPI;
      const response = await extra.sixDetailService.deleteFile(payload.sixId, payload.fileId);
      return { ...response, fileId: payload.fileId };
    })
  )
);
